import React, { Component } from 'react';
import { Translation } from 'react-i18next';
import utils from '../../../common/utils';

function Ans6() {
  return (
    <Translation>
      {(t) => (
        <div className="bg">
          <ol className="ans">
            <li>
              <b className="fisrt-line">{t('ans_6.text_1')}</b>
              <p>{t('ans_6.text_2')}</p>
            </li>
            <li>
              <b className="fisrt-line">{t('ans_6.text_3')}</b>
              <p>
                {t('deposit_fee')}
                {' '}
                BTC:
                {' '}
                {t('free')}
              </p>
              <p>
                {t('deposit_fee')}
                {' '}
                ETH:
                {' '}
                {t('free')}
              </p>
              <p>
                {t('deposit_fee')}
                {' '}
                USDT:
                {' '}
                {t('free')}
              </p>
              <p>
                {t('deposit_fee')}
                {' '}
                KNC:
                {' '}
                {t('free')}
              </p>
            </li>
            <li>
              <b className="fisrt-line">{t('ans_6.text_4')}</b>
              <p>{`${t('withdrawal_fee')} BTC:  ${utils.formatCurrency(6.67e-5)} BTC`}</p>
              <p>
                {t('withdrawal_fee')}
                {' '}
                ETH: 0.002 ETH
              </p>
              <p>
                {t('withdrawal_fee')}
                {' '}
                USDT:  2 USDT
              </p>
              <p>
                {t('withdrawal_fee')}
                {' '}
                KNC: 0.0002 KNC
              </p>
            </li>
          </ol>
        </div>
      )}
    </Translation>
  );
}

export default Ans6;
